import { usePromotionFormStoreAction } from '../stores/promotion-form.store'

export const useClearPromotionStore = () => {
  // Corrigido: chama a função para obter as ações
  const { clearPromotionForm } = usePromotionFormStoreAction()

  return {
    action: {
      clearAllStore: () => {
        clearPromotionForm()
      },
    },
  }
}